import { css } from '@emotion/react';
import { Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  bullet: ({ theme }) => css`
    display: flex;
    width: 4px;
    height: 4px;
    background-color: ${theme.colors.neutral.variant[30]};
    border-radius: 50%;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
